import React, { memo, useEffect, useState } from 'react';
import { Spin, Tooltip, Button, Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
// import '@style/modules/project/integrationNavigator.scss';
import '../../styles/modules/project/integrationNavigator.scss';
import { UserguidModal } from './userguid';
// import SectionComment from '@components/CommentCenter/SectionComment';
import SectionComment from 'src/ddvComment/SectionComment';
import IntegrationDisplay from './IntegrationDisplay';
import PDFDisplay from './PDFDisplay';
import { INTEGRATION_TYPES } from '@model';
import ImageDisplay from './imageDisplay';
import ChartWidgetSection from './ChartWidgetSection';
import TextContainerSection from '@components/hubModule/TextContainerSection';
import useRefreshPowerBI from '@hooks/useRefreshPowerBI';
import { useSelector } from 'react-redux';
// import '../../../styles/modules/project/integrationNavigator.scss';
// import '../../styles/modules/project/integrationNavigator.scss';
import { extractReportId } from '@utils/reportIDExtracter';
import { buttonRefreshPatternMatch } from '@utils/buttonRefreshPatternMatch';
import store from '@flux/store';
import actions from '@flux/action';
// import { ListItem as OriListItem, Tooltip, Button } from 'appkit-react';

//https://app.powerbi.com/groups/63b73765-ad12-4ab0-a0c8-f72a1df1f867/reports/09af5ce1-1177-4c08-8bfe-0aa88623b84e/ReportSection
// 63b73765-ad12-4ab0-a0c8-f72a1df1f867
//09af5ce1-1177-4c08-8bfe-0aa88623b84e
const IntegrationHub = (props) => {
  const {
    section: { titleName, link: propsLink = '', identifier, type },
    saveLink,
    section,
    id,
    commentAnchorId,
    changeOrderPropsValue,
    toggleEditModal,
    isMultiSection = false,
    multiSectionModuleName,
    ...rest
  } = props;
  // type === 'powerbi' && console.log('PBI props: ', props);
  const { refreshPowerBIKey, refreshBtnLoading, toggleRefreshPowerBI } =
    useRefreshPowerBI(id, propsLink, titleName, identifier, type);
  const [isModalVisible, toggleModalVisible] = useState(false);
  const [link, setLink] = useState('');
  const [powerBIRefershData, setPowerBIRefershData] = useState({});
  const [pbiRefreshDisable, setPbiRefreshDisable] = useState(false);
  const [pbiRefreshCompDisable, setPbiRefreshCompDisable] = useState(false);
  const [uniqueButtonId, setUniqueButtonId] = useState('');
  const [refreshCompleteModal, setRefreshCompleteModal] = useState(false);
  const [timer, setTimer] = useState(5); // Dynamic timer value

  const powerBIRefershReducerData = useSelector(
    (state) => state.powerBIRefreshReducer,
  );

  useEffect(() => {
    const reportId = extractReportId(link);
    setUniqueButtonId(`${reportId}_${section.identifier}`);
  }, [link]);

  useEffect(() => {
    // console.log('PBI store data', powerBIRefershReducerData);
    setPowerBIRefershData(powerBIRefershReducerData);
  }, [powerBIRefershReducerData]);

  useEffect(() => {
    if (powerBIRefershData.type === 'notification') {
      const refreshData = powerBIRefershData;
      let refreshFlagData = buttonRefreshPatternMatch(refreshData.messages);
      // console.log('refreshFlagData : ', refreshFlagData);
      if (
        refreshFlagData[0] &&
        !refreshCompleteModal &&
        refreshFlagData[1] === uniqueButtonId
      ) {
        setRefreshCompleteModal(true);
      }
    }
  }, [powerBIRefershData]);

  useEffect(() => {
    setPbiRefreshDisable(
      powerBIRefershData?.buttonList?.includes(uniqueButtonId),
    );
    // if (powerBIRefershData?.buttonList?.includes(!uniqueButtonId)) {
    //   setPbiRefreshCompDisable(false);
    //   setRefreshCompleteModal(true);
    // }
  }, [powerBIRefershData]);

  useEffect(() => {
    if (pbiRefreshCompDisable && !pbiRefreshDisable) {
      setPbiRefreshCompDisable(false);
      // setRefreshCompleteModal(true);
    }
  }, [pbiRefreshDisable]);

  const handleUserGuid = () => {
    toggleModalVisible(true);
  };

  const getCommentIconStyle = () => {
    if (link || propsLink || type === INTEGRATION_TYPES.TEXT_CONTAINER) {
      return { top: '2rem', right: '5.3125rem' };
    }
    return {};
  };

  useEffect(() => {
    let interval;
    if (refreshCompleteModal) {
      // Start countdown when modal becomes visible
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(interval);
            refreshBrowser();
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [refreshCompleteModal]);

  const refreshBrowser = () => {
    if (refreshCompleteModal) {
      window.location.reload();
    }
  };

  const isVisualWidgetChart = type === INTEGRATION_TYPES.CHART;
  const isPowerBI = type === INTEGRATION_TYPES.POWER_BI;

  const closeRefreshModal = () => {
    store.dispatch(actions.clearPBIrefreshData());
    setRefreshCompleteModal(false);
  };

  return (
    <div
      className="integration-navigator integration-hub"
      key={refreshPowerBIKey}
    >
      {refreshCompleteModal ? (
        <Modal
          className="pbirefreshmodal"
          visible={refreshCompleteModal}
          title="PBI Refresh Notification"
          closable={{ 'aria-label': 'Custom Close Button' }}
          ariaLabel="PBI Refresh Notification"
          onCancel={closeRefreshModal}
          modalStyle={{ width: '33.75rem' }}
          footerStyle={{
            paddingTop: '8px',
            marginTop: '-8px',
            minHeight: '64px',
          }}
          header={''}
          footer={
            <div>
              <button
                type="button"
                className="pbiRefreshClose"
                onClick={closeRefreshModal}
              >
                Close
              </button>
            </div>
          }
          bodyStyle={{ minHeight: '92px' }}
        >
          <p>
            Dashboard refresh complete. Refreshing browser in {timer} seconds.
          </p>
        </Modal>
      ) : (
        ''
      )}
      <div className="button-with-comment-icon" style={getCommentIconStyle()}>
        {/* {isPowerBI && (
          <Spin
            spinning={refreshBtnLoading}
            indicator={<LoadingOutlined spin />}
            size="small"
          >
            <Tooltip
              placement="topLeft"
              title={
                pbiRefreshCompDisable || pbiRefreshDisable
                  ? 'Refresh Ongoing'
                  : ''
              }
              overlayClassName="add-manage-form-tooltip"
            >
              <Button
                id={uniqueButtonId}
                className="edit-sections role-control"
                style={{
                  cursor: pbiRefreshDisable ? 'not-allowed' : 'pointer',
                }}
                onClick={() => {
                  if (!link) {
                    return;
                  }
                  setPbiRefreshCompDisable(true);
                  toggleRefreshPowerBI();
                }}
                disabled={pbiRefreshDisable || pbiRefreshCompDisable} // Disable button based on conditions
              >
                <span className="appkiticon icon-refresh-outline" />
              </Button>
            </Tooltip>
          </Spin>
          // </Tooltip>
        )} */}
        <Tooltip title={isVisualWidgetChart ? 'Comment' : null}>
          <div>
            <SectionComment
              module={isMultiSection ? multiSectionModuleName : 'Project Home'}
              component={titleName}
              placement="leftTop"
              sendIdentifier={identifier}
              getPopupContainer={() => document.body}
            />
          </div>
        </Tooltip>
        <Tooltip title={isVisualWidgetChart ? 'Customize Project Home' : null}>
          <div className="edit-sections role-control" onClick={toggleEditModal}>
            <span className="appkiticon icon-pencil-fill" />
          </div>
        </Tooltip>
      </div>
      {type === INTEGRATION_TYPES.IMG ? (
        <ImageDisplay
          identifier={identifier}
          link={propsLink}
          setLink={setLink}
          saveLink={saveLink}
          changeOrderPropsValue={changeOrderPropsValue}
          section={section}
          title={titleName}
          {...rest}
        />
      ) : type === INTEGRATION_TYPES.PDF ? (
        <PDFDisplay
          identifier={identifier}
          link={propsLink}
          setLink={setLink}
          saveLink={saveLink}
          section={section}
          titleName={titleName}
          changeOrderPropsValue={changeOrderPropsValue}
          type={type}
          {...rest}
        />
      ) : isVisualWidgetChart ? (
        <ChartWidgetSection
          identifier={identifier}
          link={propsLink}
          setLink={setLink}
          saveLink={saveLink}
          section={section}
          titleName={titleName}
          changeOrderPropsValue={changeOrderPropsValue}
          type={type}
          {...rest}
        />
      ) : type === INTEGRATION_TYPES.TEXT_CONTAINER ? (
        <TextContainerSection
          identifier={identifier}
          link={propsLink}
          setLink={setLink}
          saveLink={saveLink}
          section={section}
          titleName={titleName}
          changeOrderPropsValue={changeOrderPropsValue}
          type={type}
          {...rest}
        />
      ) : (
        <IntegrationDisplay
          propsLink={propsLink}
          identifier={identifier}
          link={link}
          setLink={setLink}
          titleName={titleName}
          section={section}
          handleUserGuid={handleUserGuid}
          saveLink={saveLink}
          type={type}
          changeOrderPropsValue={changeOrderPropsValue}
          {...rest}
        />
      )}
      <UserguidModal
        isModalVisible={isModalVisible}
        toggleModalVisible={toggleModalVisible}
      />
    </div>
  );
};
export default memo(IntegrationHub);
